import React from "react";
import { Link } from "react-router-dom";
import "./Style.css";

const NotReady = () => {
  return (
    <>
      <div className='flex justify-center items-center h-screen flex-col NotReady__page'>
        <h1 className='md:text-4xl sm:text-3xl text-2xl text-white'>
          ...هذه الصفحة غير موجودة حاليا
        </h1>
        <Link to='/'>
          <button className='md:text-3xl sm:text-2xl text-xl bg-primary p-4 rounded-full mt-4 text-white hover:bg-purple-900'>
            الصفحة الرئيسية
          </button>
        </Link>
      </div>
    </>
  );
};

export default NotReady;
